<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.name" placeholder="名称"></el-input>
                </div>
            </div> 
            &nbsp;
            <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                <!-- <el-button type="danger"  v-if="currUserId == 1" @click="setCopy()">复制</el-button> -->
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
                <el-table-column prop="name" label="维度名称"   :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="五育类型"   width="110px" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 1">
                            德育
                        </div>
                        <div v-else-if="scope.row.type == 2">
                            智育
                        </div>
                        <div v-else-if="scope.row.type == 3">
                            体育
                        </div>
                        <div v-else-if="scope.row.type == 4">
                            美育
                        </div>
                        <div v-else-if="scope.row.type == 5">
                            劳育
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNum" label="排序号" width="60"></el-table-column>
                <el-table-column fixed="right" label="操作" width="110px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <!-- <div v-if="setCopyVisible">
            <setCopy ref="setCopy"></setCopy>
        </div> -->
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import add from './AddType.vue';
    import update from './UpdateType.vue';
    // import setCopy from './SetCopy.vue';

    export default {
        name:"EvaluateMain",
        data(){
            return{
                loading:false,
                addVisible:false,
                updateVisible:false,
                // setCopyVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    name:""
                },
                currUserId:"",
                data:[],
                depts:[]
            }
        },
        components: {
            add,update
        },
        created:function () {
            this.getDeptData();
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.evaluateTypeListUrl;
                let data = {
                    deptId:this.form.deptId,
                    name:this.form.name
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.evaluateTypeRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            // setCopy(){ // 复制对象
            //     this.setCopyVisible=true;
            //     this.$nextTick(() => {
            //         this.$refs['setCopy'].init(this.form.deptId);
            //     })
            // },
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/EvaluateType.vue